import React, { useEffect, useRef, useState } from "react";
import { DoctorDetails, Image, Map, AccordionList, AppointmentSchedule } from "../../components/componentIndex";
import MarkLocationIcon from "../../assets/images/doctorProfile/map-marker.svg";
import homeIcon from "../../assets/images/home.svg";
import phoneIcon from "../../assets/images/phone.svg";
import LeftChevron from '../../assets/images/left-chevron.svg';
import { Button } from "../../common/commonIndex";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import VisitService from '../../services/API/visitService';
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";

const AppointmentDetail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isVisitCancelPopUp, setIsVisitCancelPopUp] = useState(false);
  const { state: data } = useAuthenticationContext();
  const popupRef = useRef(null);
  
  const handleFreAskedQuestions = () => {
    window.open('https://gutchek.io/faq', '_blank'); // Open in a new tab
  }
  const handleGetHelp = () => {
    const recipient = "support@gutcheck.io";
    const subject = "Help Request";
    const body = "Hi, I need help with...";

    // Open the default email client with pre-filled details
    window.location.href = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  useEffect(() => {
    getVisitDetails();
  }, [])

  const getVisitDetails = async () => {
    try {
      const accessToken = data?.userData?.result?.token;
      setIsLoading(true);
      let visitId = searchParams.get('visitId')
      const response = await VisitService.getVisitDetails(visitId, accessToken);
      if (response?.statusCode === 200) {
        let list = response.result;
        list['doctorInfo'] = {
          name: list.firstName + ' ' + list.lastName + ', ' + list.credential,
          specialization: list.specialtyName,
          photo: list.doctorProfileSignedUrl,
          firstName: list.firstName,
          lastName: list.lastName
        }
        setAppointmentDetails(list);

      } else {
        toast.error(response?.message);
      }
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      console.error("Login failed: ", error);
    }
  }
  const cancelVisit = async () => {
    try {
      const accessToken = data?.userData?.result?.token;
      setIsLoading(true);
      let visitId = searchParams.get('visitId')
      const response = await VisitService.cancelVisit(visitId, accessToken);
      if (response?.statusCode === 200) {
        handleBackScreen();
      } else {
        toast.error(response?.message);
      }
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      console.error("Login failed: ", error);
    }
  }
  const openFullScreen = () => {
    setIsFullScreen(true);
  };
  const closeFullScreen = () => {
    setIsFullScreen(false);
  };

  const handleCancleAppointment = () => {
    // cancelVisit
    setIsVisitCancelPopUp(!isVisitCancelPopUp);
    // navigate('/landing');
  }
  const handleBackScreen = () => {
    navigate('/visits');
  }
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsFullScreen(false);
        setIsVisitCancelPopUp(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [closeFullScreen, isVisitCancelPopUp]);

  // Function to launch Google Maps
  const launchMap = (latitude, longitude) => {
    const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(mapUrl, "_blank"); // Opens in a new tab
  };

  const handleCallSurgeryCenter = (surgeryCenterContactNumber) => {
    if (surgeryCenterContactNumber) {
      window.location.href = `tel:+${surgeryCenterContactNumber}`;
    }
  };

  return (
    <div className="custom-container appintment-detail appointment-details">
      <div className="d-flex align-items-center justify-content-start">
        <div onClick={handleBackScreen} className='cursor-pointer confirm-req-back'>
          <Image imgUrl={LeftChevron} altText={'Left Chevron'} />
        </div>
        <h2 className="page-title">Your appointment</h2>
      </div>
      <div
        className="cursor-pointer appintment-bg"
        style={{
          backgroundImage: `url(${appointmentDetails?.coverImageSignedUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <div className="show-all-badge">
              <span className="badge badge-white"> <Image imgUrl={ImgIcon} altText={'imgage'} className={'me-2'} /> Show all photos</span>
            </div> */}
      </div>
      <div className="mt-4">
        <h3 className="appointment-details-type">
          {appointmentDetails?.appointmentType}
        </h3>
        <p className="appointment-details-datetime">
          {appointmentDetails?.appointmentDate} {appointmentDetails?.timeSlot}
        </p>
      </div>

      <div className="divider my-3"></div>
      <div className="hospital-detail">
        <div className="d-flex align-items-center mb-3 app-hospital-detail">
          <Image
            imgUrl={homeIcon}
            altText={"mark location"}
            className={"me-3"}
          />
          <p className="">{appointmentDetails?.surgeryCenter}</p>
        </div>
        <div className="d-flex align-items-center mb-3">
          <Image
            imgUrl={MarkLocationIcon}
            altText={"mark location"}
            className={"margin-right-10"}
          />
          <p className="cursor-pointer" onClick={() => launchMap(appointmentDetails?.latitude ?? 0, appointmentDetails?.longitude ?? 0)}>{appointmentDetails?.surgeryCenterAddress}</p>
        </div>
        <div className="d-flex align-items-center mb-3">
          <Image
            imgUrl={phoneIcon}
            altText={"mark location"}
            className={"me-3"}
          />
          <p className="cursor-pointer" onClick={() => handleCallSurgeryCenter(appointmentDetails?.surgeryCenterContactNumber)}>Call surgery center</p>
          <p></p>
        </div>
      </div>

      <div className="divider my-3"></div>

      <div className="app-title mb-4 mt-2" dangerouslySetInnerHTML={{ __html: appointmentDetails?.appointmentDetails?.title }} />
      <div className="appointment-details-text pt-3">
        <div className="app-description" dangerouslySetInnerHTML={{ __html: appointmentDetails?.appointmentDetails?.description }} />
      </div>

      {/* <div className="divider my-3"></div> */}

      <div>
        {(appointmentDetails?.billingInformationDetails || appointmentDetails?.cancellationPolicyDetails) ? (
          <AccordionList
            list={[
              appointmentDetails?.billingInformationDetails,
              appointmentDetails?.cancellationPolicyDetails,
            ]}
          />
        ) : null}
      </div>
      {appointmentDetails?.medicationDetails && (
        <div className="medication">
          <div className="app-sub-title app-medication-title my-4">{appointmentDetails?.medicationDetails?.title}</div>
          <div className="app-description app-medication-details" dangerouslySetInnerHTML={{ __html: appointmentDetails?.medicationDetails?.description }} >
          </div>
        </div>
      )}


      <div className="divider my-3"></div>

      <div className="medication">
        <h3 className="app-sub-title app-prep-inst">{appointmentDetails?.visitPrepInstructions?.prepInstruction} Prep Instructions</h3>

        {/* <TimeLine /> */}
        <div className="colonoscopy-instructions medication-detail timeline">
          {appointmentDetails?.visitPrepInstructions?.listPrepInstructionDetails?.length > 0 ? (
            <div className="timeline-item">
              {appointmentDetails.visitPrepInstructions.listPrepInstructionDetails.map((item, index) => (
                <div className="content" key={index}>
                  <div className="position-relative">
                    <div className="timeline-dot"></div>
                    <h4 className="timeline-title timeline-sub-title">{item?.title}</h4>
                    <div className="app-description timeline-description" dangerouslySetInnerHTML={{ __html: item.description }} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div><p className="not-found-txt">No Prep Instructions</p></div>
          )}
        </div>
      </div>

      <div className="divider my-3"></div>

      <div className="where-to-go medication">
        <h4 className="app-sub-title">Where to go </h4>

        <div className="where-to-go-address d-flex align-items-center mb-3 mt-3">
          <Image
            imgUrl={MarkLocationIcon}
            altText={"mark location"}
          />
          <p className="where-to-go-location mb-0 cursor-pointer" onClick={() => launchMap(appointmentDetails?.latitude ?? 0, appointmentDetails?.longitude ?? 0)}> {appointmentDetails?.surgeryCenterAddress}</p>
        </div>
        {appointmentDetails?.latitude && appointmentDetails?.longitude && (
          <Map position={[appointmentDetails?.latitude, appointmentDetails?.longitude]} />
        )}

      </div>

      <div className="divider my-3"></div>

      <div className="about-doctor medication">
        <h4 className="about-doctor-text mb-4">About your doctor</h4>
        {appointmentDetails?.doctorInfo && (
          <DoctorDetails doctorInformation={appointmentDetails?.doctorInfo} />
        )}
      </div>

      <div className="divider my-3"></div>
      <div className="medication">
        <h4 className="app-sub-title mb-3">Support</h4>
      </div>
      <div className="divider my-3"></div>
      <div className="support">
        <div className="d-flex justify-content-between align-items-center cursor-pointer" onClick={handleFreAskedQuestions}>
          <p className="app-description support-titles my-2">Frequently asked questions</p>
          <Image imgUrl={LeftChevron} altText={'Chevron'} className={''} />
        </div>
        <div className="divider my-3"></div>
        <div className="d-flex justify-content-between align-items-center cursor-pointer" onClick={handleGetHelp}>
          <p className="app-description support-titles my-2">Get help</p>
          <Image imgUrl={LeftChevron} altText={'Chevron'} className={''} />
        </div>
      </div>
      <div className="divider my-3"></div>
      {/* <AccordionList list={supportAccList} /> */}
      <div className="d-flex align-items-start my-3">
        <Button btnType={'button'} btnClass={'btn-secondary cancel-btn'} btnName={'Cancel'} isDisabled={true} onClick={handleCancleAppointment} />
        <Button btnType={'button'} btnClass={'btn-primary reschedule-btn ms-3'} btnName={'Reschedule'} isDisabled={true} onClick={openFullScreen} />
      </div>

      {isFullScreen && (
        <AppointmentSchedule appointmentData={appointmentDetails} closeFullScreen={closeFullScreen} />
      )}

      {isVisitCancelPopUp && (
        <div className="fullscreen-overlay">
          <div className={`fullscreen-overlay-content  cancel-appointment-popup`} ref={popupRef}>
            <div className="alert-container">
              <h2 className="title mt-3">
                Are you sure about canceling the appointment?
              </h2>

            </div>
            <div className="d-flex align-items-center justify-content-end mt-4">
              <Button btnClass={'btn-secondary cancel-btn me-2'}
                btnName={'Cancel'}
                btnType={'button'}
                onClick={handleCancleAppointment}
                isDisabled={true}
              />
              <Button btnClass={'btn-primary ms-2'}
                btnName={'Sure'}
                btnType={'button'}
                onClick={cancelVisit}
                isDisabled={true}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentDetail;
